/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { UsageTrendContext } from '../contexts';

export const useUsageTrendStore = () => useContext(UsageTrendContext);
